<template>
    <section id="mapInfo2" v-if="isShow">
        <h3>商家信息</h3>
        <div  class="map">
            <span class="mapInfo">{{mapinfoData2.name}}</span>
            <ul class="star il">
                <!--评分-->
                <li v-for="(n, index) in 5" :key="index" :class='n|star(mapinfoData2.startNum)'></li>
            </ul>
        </div>
        <router-link to="'baiduMap/'+&" class="distance">
            {{mapinfoData2.map}}
        </router-link>
        <a href="javascript:;" class="phone" @click="callphone()"></a>
        <a class="merchantTime" v-if="+mapinfoData2.distance>0" :href="bdmapUrl"><span>距离您{{+mapinfoData2.distance | filteDistance}}</span></a>
        <mt-actionsheet
                :actions="mapinfoData2.actions"
                v-model="sheetVisible">
        </mt-actionsheet>
    </section>
</template>

<script>
    export default {
        data(){
            return{
                sheetVisible:false,
                isShow:false,
                bdmapUrl:''
            }
        },
        watch:{
            mapinfoData2(curVal,oldVal){
                this.bdmapUrl = 'http://api.map.baidu.com/marker?location='+this.mapinfoData2.shopAddr.latitude+','+this.mapinfoData2.shopAddr.longitude+',116.41004950566&title='+this.mapinfoData2.name+'&content='+this.mapinfoData2.map+'&output=html';
                if(Object.keys(curVal).length){
                    this.isShow = true;
                }
            }
        },
        created() {
            if(Object.keys(this.mapinfoData2).length){
                this.isShow = true;
            }
        },
        props:["mapinfoData2"],
        methods:{
            callphone(){
                this.sheetVisible = true;
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #mapInfo2{
        background-color: #fff;
        margin-bottom: px2rem(13);
        padding:px2rem(12);
        position: relative;
        padding-top: 0;
        h3{
            height:px2rem(40);
            line-height: px2rem(40);
            border-bottom: px2rem(1) solid #eee;
            font-size: px2rem(14);
            color: #999;
            margin-bottom: px2rem(12);
        }
        .map{
            position: relative;
            font-size: px2rem(14);
            line-height: px2rem(20);
            color: #333;
            span.mapInfo{
                display: inline-block;
                max-width: 45%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            ul.star{
                margin-left: px2rem(12);
                li{
                    float: left;
                    width:px2rem(14);
                    height: px2rem(14);
                    margin-right: px2rem(4);
                    background: url("../../assets/img/start.png") no-repeat 0 0;
                    background-size: cover;
                }
                li.full{
                    background-position:px2rem(-15) center ;
                }
                li.half{
                    background-position: px2rem(-29) center;
                }
            }
        }
        a{
            color: #999;
            font-size: px2rem(14);
            line-height: px2rem(20);
            span{
                padding-right: px2rem(24);
            }
        }
        a.phone{
            box-sizing: content-box;
            position: absolute;
            top:px2rem(51);
            right:px2rem(11);
            width:px2rem(24);
            height:px2rem(24);
            padding:px2rem(10) px2rem(24);
            border-left: px2rem(1) solid #eee;
            background: url(../../assets/img/food_phone.png) no-repeat center;
            background-origin: content-box;
            background-size: 100% 100%;
        }
        a.distance{
            margin-top: px2rem(10);
            display: inline-block;
            max-width: 75%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        a.merchantTime{
            display: block;
            border-top: px2rem(1) solid #eee;
            margin-top: px2rem(12);
            padding-top: px2rem(15);
            padding-left: px2rem(24);
            color: #666;
            font-size: px2rem(14);
            line-height: px2rem(20);
            position: relative;
            &:before{
                content: "";
                width:px2rem(24);
                height: px2rem(24);
                background-image: url(../../assets/img/food_locate.png);
                background-size: 100% 100%;
                position: absolute;
                left:px2rem(0);
                bottom:px2rem(0);
            }
        }
        .mint-actionsheet{
            padding:px2rem(9) px2rem(10);
            background-color: transparent;
            .mint-actionsheet-list{
                margin-bottom: px2rem(10) !important;
                border-radius: px2rem(12);
                li:first-child{
                    border-top-left-radius: px2rem(12);
                    border-top-right-radius: px2rem(12);
                }
                li:last-child{
                    border-bottom-left-radius: px2rem(12);
                    border-bottom-right-radius: px2rem(12);
                }
            }
            .mint-actionsheet-listitem, .mint-actionsheet-button{
                height:px2rem(45);
                line-height: px2rem(45);
                font-size: px2rem(18);
                color: #0076FF ;
            }
            .mint-actionsheet-button{
                border-radius: px2rem(12);
            }
        }
    }
</style>
